<!--
/**
 * DjRestartTab.vue - 停复机 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的停复机管理页面，用于对号码进行停机和复机操作，
 * 支持手动输入和文件批量上传两种模式，同时提供停复机记录查询、自动复机设置等功能。
 *
 * 【主要功能】
 * 1. 停复机记录查询 - 按代理商、企业、号码、订单编号、类型、状态、原因等条件查询
 * 2. 手动停复机 - 手动输入号码进行停机或复机操作
 * 3. 文件批量停复机 - 通过上传txt文件批量执行停复机操作
 * 4. 自动复机设置 - 设置停机后多久自动复机
 * 5. 记录下载 - 下载指定批次的停复机数据
 * 6. 数据导出 - 按原因关键词导出停复机记录
 *
 * 【权限要求】
 * - 所有用户：可查询记录、执行停复机操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 代理商下拉选择框 -->
      <el-select size="small" @change="onAgentChange" v-model="query3.agentId" filterable clearable
                 placeholder="代理商" class="handle-select mr10" style="width: 260px">
        <el-option v-for="item in agents" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 企业下拉选择框（与代理商联动） -->
      <el-select size="small" style="width: 260px" v-model="query3.companyId" @change="onCompanyChange"
                 filterable clearable placeholder="企业" class="handle-select mr10">
        <el-option v-for="item in companys" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query3.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 订单编号输入框 -->
      <el-input size="small" v-model="query3.uid" clearable placeholder="订单编号" style="width: 230px;"
                class="handle-input mr10"></el-input>
      <!-- 类型筛选（全部/复机/停机） -->
      <el-select size="small" style="width: 100px" v-model="query3.status" filterable clearable
                 placeholder="类型" class="handle-select mr10">
        <el-option v-for="item in rechargeList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 状态筛选（全部/成功/失败） -->
      <el-select size="small" style="width: 100px" v-model="query3.succeed" filterable clearable
                 placeholder="状态" class="handle-select mr10">
        <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 原因关键词输入框 -->
      <el-input size="small" v-model="query3.operateMsg" clearable placeholder="请输入原因"
                class="handle-input mr10" style="width: 180px;"></el-input>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                 @click="getstopOrOpenRecord">搜索
      </el-button>
      <!-- 添加停复机按钮 - 打开添加弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
                 @click="handleAdd3">添加停复机
      </el-button>
      <!-- 导出按钮 - 按原因关键词导出数据（仅有原因筛选条件时显示） -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
                 @click="exportData" v-if="query3.operateMsg">导出
      </el-button>
    </div>

    <!-- ========== 停复机记录表格 ========== -->
    <el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 代理商列 -->
      <el-table-column prop="agent" label="代理商" align="center" show-overflow-tooltip></el-table-column>
      <!-- 企业名称列 -->
      <el-table-column prop="company" label="企业名称" align="center" show-overflow-tooltip></el-table-column>
      <!-- 手机号列 -->
      <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
      <!-- 状态列（提交失败时红色显示，悬浮提示错误原因） -->
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                      v-if="scope.row.status == '提交失败'">
            <span style="color: #f56c6c;">{{ scope.row.status }}</span>
          </el-tooltip>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <!-- 类型列（停机=红色，复机=绿色） -->
      <el-table-column prop="type" label="类型" align="center" width="120">
        <template #default="scope">
          <span v-if="scope.row.type == '停机'" class="status_color2 bgred">{{ scope.row.type }}</span>
          <span v-if="scope.row.type == '复机'" class="status_color2 bggreen">{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <!-- 原因列 -->
      <el-table-column prop="operateMsg" label="原因" align="center" show-overflow-tooltip></el-table-column>
      <!-- 记录时间列 -->
      <el-table-column prop="createdAt" label="记录时间" align="center" width="155"></el-table-column>
      <!-- 复机操作列 - 点击打开自动复机设置弹窗 -->
      <el-table-column label="复机" align="center" width="100">
        <template #default="scope">
          <span @click="getRecordVisible(scope.row)" style="cursor: pointer;color: #ff0000;">记录复机</span>
        </template>
      </el-table-column>
      <!-- 操作者列 -->
      <el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
      <!-- 订单编号列（含下载和复制功能） -->
      <el-table-column prop="uid" label="订单编号" width="350" align="center">
        <template #default="scope">
          <span style="cursor: pointer;">
            <!-- 下载该批次停复机数据 -->
            <i @click="getdownloadStopOrOpenRecord(scope.row.uid)" class="el-icon-download"
               :class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
            <!-- 点击复制订单编号 -->
            <span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 添加停复机弹窗 ========== -->
    <!-- 支持手动输入和文件上传两种模式 -->
    <el-dialog title="添加停复机" v-model="addVisible3" width="520px" @close="closeDialog3">
      <el-form label-width="120px" :model="addForm3" ref="addForm3">
        <!-- 选择模式：手动输入 或 批量停开机模板 -->
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">批量停开机模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 类型选择：开机 或 停机 -->
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm3.type">
            <el-radio label="OPEN">开机</el-radio>
            <el-radio label="STOP">停机</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手动输入模式：输入手机号码（一行一个，最多500个） -->
        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm3.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <!-- 文件上传模式：上传txt文件 -->
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload3" action="/api/dxt/FileStopOrOpen" :headers="token" :limit="1"
                     :on-success="uploadSuccess3" :auto-upload="false" :data="addForm3">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top:40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <!-- 停复机原因 -->
        <el-form-item label="原因" prop="operateMsg">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm3.operateMsg" auto-complete="off"
                    placeholder="请输入停复机原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog3">取消</el-button>
          <!-- 手动输入模式：点击确定调用API -->
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="getstopOrOpens3">确定
          </el-button>
          <!-- 文件上传模式：点击确定触发上传 -->
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload3">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== 自动复机设置弹窗 ========== -->
    <el-dialog title="自动复机设置" v-model="repeatedVisible" width="520px" @close="closeDialog3">
      <el-form label-width="120px" :model="repeatedForm" ref="repeatedForm">
        <!-- 是否记录（标记需要自动复机） -->
        <el-form-item label="是否记录" prop="record">
          <el-radio-group v-model="repeatedForm.record">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 是否复机（只读展示） -->
        <el-form-item label="是否复机" prop="recover">
          <el-radio-group v-model="repeatedForm.recover" disabled>
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 复机延迟时间选择 -->
        <el-form-item label="复机时间" prop="hours" v-if="repeatedForm.record">
          <el-radio-group v-model="repeatedForm.hours">
            <el-radio v-for="item in hoursList" :key="item.value" :label="item.value" :value="item.value"
                      style="margin: 12px 52px 12px 0;">{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 记录时间（只读） -->
        <el-form-item label="记录时间" prop="updatedAt">
          <el-input size="small" v-model="repeatedForm.updatedAt" disabled></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog3">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getRecordingRecover">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 停复机 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - fetchCompanyByAgentId：根据代理商ID获取企业列表
 * - fetchDefaultCompanies：获取默认企业列表
 * - stopOrOpenRecord：查询停复机记录
 * - stopOrOpen：执行停机/复机操作
 * - downloadStopOrOpenRecord：下载停复机记录数据
 * - dxtRecordingRecover：设置自动复机
 */
import {
  fetchCompanyByAgentId,
  fetchDefaultCompanies
} from '../../../api/companyIndex';
import {
  stopOrOpenRecord,
  stopOrOpen,
  downloadStopOrOpenRecord,
  dxtRecordingRecover
} from '../../../api/dijia.js';

export default {
  name: 'DjRestartTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - theme3：辅助主题颜色类名（用于下载图标颜色）
   * - agents：代理商列表（用于下拉筛选）
   * - token：请求头信息（包含认证令牌），用于文件上传时的鉴权
   */
  props: {
    theme: { type: String, default: '' },
    theme3: { type: String, default: '' },
    agents: { type: Array, default: () => [] },
    token: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      companys: [],             // 企业列表
      query3: {                 // 查询参数对象
        companyId: '',          // 企业ID
        agentId: '',            // 代理商ID
        userId: localStorage.getItem('user'),  // 当前用户ID
        status: '',             // 类型筛选（1=复机，-1=停机）
        phone: '',              // 手机号
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        uid: '',                // 订单编号
        succeed: '',            // 状态筛选（1=成功，-1=失败）
        operateMsg: '',         // 原因关键词
      },
      tableData3: [],           // 停复机记录列表
      pageTotal3: 0,            // 总条数
      rechargeList: [           // 类型筛选选项
        { value: 0, label: '全部' },
        { value: 1, label: '复机' },
        { value: -1, label: '停机' }
      ],
      succeedList2: [           // 状态筛选选项
        { value: 0, label: '全部' },
        { value: 1, label: '成功' },
        { value: -1, label: '失败' }
      ],

      // ========== 添加停复机弹窗相关 ==========
      addVisible3: false,       // 弹窗是否显示
      addForm3: {               // 添加表单数据
        phones: '',             // 手机号（一行一个）
        userId: localStorage.getItem('user'),
        operateMsg: '',         // 操作原因
        type: 'OPEN',           // 操作类型（OPEN=开机，STOP=停机）
      },
      tab1: 'input',            // 当前模式（input=手动输入，fled=文件上传）

      // ========== 自动复机弹窗相关 ==========
      repeatedVisible: false,   // 自动复机弹窗是否显示
      repeatedForm: {           // 自动复机表单
        record: false,          // 是否记录
        recover: false,         // 是否复机
        updatedAt: '',          // 记录时间
        hours: '',              // 复机延迟小时数
      },
      hoursList: [              // 可选延迟时间
        { value: 2, label: '2小时' },
        { value: 4, label: '4小时' },
        { value: 6, label: '6小时' },
        { value: 12, label: '12小时' },
        { value: 24, label: '24小时' }
      ],
    };
  },

  /**
   * 组件创建时的生命周期钩子
   * 1. 初始化企业列表
   * 2. 查询停复机记录
   */
  created() {
    this.initCompanies();
    this.getstopOrOpenRecord();
  },

  methods: {
    /**
     * initCompanies - 初始化企业列表
     */
    initCompanies() {
      let data = {
        currentUserId: localStorage.getItem('user'),
        subAgentId: ''
      };
      fetchDefaultCompanies(data).then(res => {
        if (res?.code === 200) {
          this.companys = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * onAgentChange - 代理商选择变化回调
     * @param {string} agentId - 选中的代理商ID
     */
    onAgentChange(agentId) {
      this.query3.agentId = agentId;
      this.query3.companyId = '';
      if (agentId) {
        let data = {
          subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
          agentId: agentId
        };
        fetchCompanyByAgentId(data).then(res => {
          this.companys = res.data;
        });
      } else {
        this.initCompanies();
      }
    },

    /** onCompanyChange - 企业选择变化回调（暂未实现） */
    onCompanyChange() {},

    /**
     * exportData - 导出停复机记录
     * 按原因关键词导出数据为Excel文件
     */
    exportData() {
      this.loading = true;
      let data = { operateMsg: this.query3.operateMsg };
      downloadStopOrOpenRecord(data).then(res => {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        let fileName = '迪加停复机' + '.xls';
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        this.loading = false;
      });
    },

    /**
     * getstopOrOpenRecord - 查询停复机记录列表
     */
    getstopOrOpenRecord() {
      this.loading = true;
      stopOrOpenRecord(this.query3).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData3 = res.data.list;
          this.pageTotal3 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handleAdd3 - 打开添加停复机弹窗
     */
    handleAdd3() {
      this.addVisible3 = true;
    },

    /**
     * getstopOrOpens3 - 手动输入模式提交停复机
     * 将表单数据提交到后端执行停机或复机操作
     */
    getstopOrOpens3() {
      stopOrOpen(this.addForm3).then(res => {
        if (res?.code === 200) {
          this.addVisible3 = false;
          this.$message.success(res.data);
          setTimeout(() => {
            this.getstopOrOpenRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * submitUpload3 - 文件上传模式提交停复机
     * 检查是否选择了文件后触发上传
     */
    submitUpload3() {
      if (this.$refs.upload3.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload3.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    /**
     * uploadSuccess3 - 文件上传成功回调
     * @param {Object} success - 上传接口返回的结果
     */
    uploadSuccess3(success) {
      setTimeout(() => {
        this.$refs.upload3.clearFiles();
        this.addVisible3 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getstopOrOpenRecord();
      } else {
        this.$message.error(success.message);
      }
    },

    /**
     * getdownloadStopOrOpenRecord - 下载指定批次的停复机数据
     * @param {string} orderId - 订单编号
     */
    getdownloadStopOrOpenRecord(orderId) {
      this.$confirm('确定要下载该批次数据吗？', '提示', { type: 'warning' })
        .then(() => {
          let data = { orderId: orderId };
          downloadStopOrOpenRecord(data).then(res => {
            const blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            });
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            let fileName = '停复机记录' + orderId + '.xlsx';
            downloadElement.download = fileName;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          });
        })
        .catch(() => {});
    },

    /**
     * getRecordVisible - 打开自动复机设置弹窗
     * @param {Object} row - 停复机记录行数据
     */
    getRecordVisible(row) {
      this.repeatedVisible = true;
      this.repeatedForm.record = row.record;
      this.repeatedForm.recover = row.recover;
      this.repeatedForm.id = row.id;
      this.repeatedForm.hours = row.hours;
      this.repeatedForm.updatedAt = row.updatedAt;
    },

    /**
     * closeDialog3 - 关闭所有弹窗并重置表单
     */
    closeDialog3() {
      this.addVisible3 = false;
      this.addForm3.phones = '';
      this.addForm3.operateMsg = '';
      this.addForm3.type = 'OPEN';
      this.tab1 = 'input';
      this.repeatedVisible = false;
    },

    /**
     * getRecordingRecover - 提交自动复机设置
     */
    getRecordingRecover() {
      let data = {
        id: this.repeatedForm.id,
        record: this.repeatedForm.record,
        hours: this.repeatedForm.hours
      };
      dxtRecordingRecover(data).then(res => {
        if (res?.code === 200) {
          this.repeatedVisible = false;
          this.$message.success(res.data);
          this.getstopOrOpenRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * copyUrl - 复制文本到剪贴板
     * @param {string} item - 要复制的文本
     */
    copyUrl(item) {
      let cInput = document.createElement('input');
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$message.success('复制成功');
      document.body.removeChild(cInput);
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query3.pageIndex = val;
      this.getstopOrOpenRecord();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query3.pageSize = val;
      this.query3.pageIndex = 1;
      this.getstopOrOpenRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
